/* FootCourt order tracking — rebuilt 2026-08-08.
 *
 * Talks to the Bosta Hub tracking API. The path is /webhook/track/... because
 * Cloudflare challenges every other path on bosta.footcourt-eg.com and a
 * cross-origin fetch() cannot solve a challenge page.
 *
 * Links sent by WhatsApp look like:
 *   /pages/track-order?order=94128&sig=<hmac>   → opens straight to the result
 * Manual lookups accept an order number (then the last 4 phone digits are asked
 * for), a Bosta tracking number, or the phone the order was placed with.
 */
(function () {
  "use strict";

  // window.FCT_API lets a staging/LAN page point the same file at another origin.
  var API = window.FCT_API || "https://bosta.footcourt-eg.com/webhook/track/";
  var SUPPORT_WA = "https://wa.me/201272984271";

  var root = document.getElementById("footcourt-tracker");
  if (!root) return;

  var isAr = (document.documentElement.lang || "ar").toLowerCase().indexOf("ar") === 0;

  var T = isAr ? {
    title: "تتبع طلبك",
    sub: "اكتب رقم الطلب أو رقم الشحنة أو رقم الموبايل، وهنوريك حالة الشحنة أولاً بأول.",
    ph: "رقم الطلب أو رقم الشحنة…",
    phPhone: "آخر 4 أرقام من الموبايل",
    btn: "تتبع",
    loading: "بنجيب بيانات شحنتك…",
    errTitle: "مفيش شحنة بالبيانات دي",
    errSub: "اتأكد من رقم الطلب أو رقم الشحنة وحاول تاني.",
    needPhone: "للتأكيد، اكتب آخر 4 أرقام من رقم الموبايل الخاص بالطلب.",
    wrongPhone: "الأرقام دي مش مطابقة للطلب. حاول تاني.",
    rate: "محاولات كتير في وقت قصير. استنى شوية وحاول تاني.",
    offline: "حصلت مشكلة في الاتصال. حاول تاني بعد لحظات.",
    order: "طلب رقم",
    placedOn: "تاريخ الطلب",
    trackingNo: "رقم الشحنة",
    promise: "موعد التسليم المتوقع",
    deliveredOn: "تم التسليم في",
    attempts: "محاولات التوصيل",
    address: "منطقة التوصيل",
    phone: "موبايل المستلم",
    timeline: "مراحل الشحنة",
    items: "منتجات الطلب",
    summary: "ملخص الحساب",
    subtotal: "إجمالي المنتجات",
    shipping: "الشحن",
    discount: "الخصم",
    total: "الإجمالي",
    qty: "الكمية",
    currency: "ج.م",
    notShipped: "الطلب اتسجل عندنا ولسه ما اتشحنش. هيظهر رقم الشحنة هنا أول ما يخرج من المخزن.",
    helpText: "محتاج مساعدة في طلبك؟",
    helpBtn: "كلمنا على واتساب",
    bostaBtn: "صفحة بوسطة",
    steps: {
      10: "تم استلام الطلب",
      20: "تم استلام الشحنة من المتجر",
      21: "الشحنة في الطريق",
      22: "خارج للتسليم الآن",
      24: "تم التسليم بنجاح",
      47: "حالة استثنائية",
      48: "مرتجع للمتجر"
    }
  } : {
    title: "Track your order",
    sub: "Enter your order number, tracking number or phone to follow your shipment.",
    ph: "Order number or tracking number…",
    phPhone: "Last 4 digits of phone",
    btn: "Track",
    loading: "Fetching your shipment…",
    errTitle: "No shipment found",
    errSub: "Check the order or tracking number and try again.",
    needPhone: "For your privacy, enter the last 4 digits of the order's phone.",
    wrongPhone: "Those digits don't match this order. Try again.",
    rate: "Too many attempts. Please wait a moment and retry.",
    offline: "Connection problem. Please try again shortly.",
    order: "Order",
    placedOn: "Placed on",
    trackingNo: "Tracking number",
    promise: "Expected delivery",
    deliveredOn: "Delivered on",
    attempts: "Delivery attempts",
    address: "Delivery area",
    phone: "Receiver phone",
    timeline: "Shipment progress",
    items: "Items",
    summary: "Order summary",
    subtotal: "Subtotal",
    shipping: "Shipping",
    discount: "Discount",
    total: "Total",
    qty: "Qty",
    currency: "EGP",
    notShipped: "We have your order. The tracking number appears here once it leaves our warehouse.",
    helpText: "Need help with this order?",
    helpBtn: "Chat on WhatsApp",
    bostaBtn: "Bosta page",
    steps: {
      10: "Order placed",
      20: "Picked up from store",
      21: "In transit",
      22: "Out for delivery",
      24: "Delivered",
      47: "Exception",
      48: "Returned to store"
    }
  };

  var STEP_ORDER = [10, 20, 21, 22, 24];

  var ICONS = {
    10: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2h12l2 5H4z"/><path d="M4 7v13h16V7"/><path d="M10 12h4"/></svg>',
    20: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7h11v10H3z"/><path d="M14 10h4l3 3v4h-7z"/><circle cx="7" cy="19" r="2"/><circle cx="17" cy="19" r="2"/></svg>',
    21: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7h11v10H3z"/><path d="M14 10h4l3 3v4h-7z"/><circle cx="7" cy="19" r="2"/><circle cx="17" cy="19" r="2"/></svg>',
    22: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21s7-6.2 7-11a7 7 0 1 0-14 0c0 4.8 7 11 7 11z"/><circle cx="12" cy="10" r="2.5"/></svg>',
    24: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>',
    47: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 8v5"/><path d="M12 17h.01"/><circle cx="12" cy="12" r="9"/></svg>',
    48: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 1 0 3-6.7"/><path d="M3 4v5h5"/></svg>'
  };

  var TONE = { 10: "slate", 20: "blue", 21: "blue", 22: "amber", 24: "green", 47: "red", 48: "red" };

  var WA_ICON = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2a10 10 0 0 0-8.6 15L2 22l5.2-1.4A10 10 0 1 0 12 2zm5.6 14.1c-.2.7-1.3 1.3-1.9 1.4-.5.1-1.1.1-1.8-.1-.4-.1-.9-.3-1.6-.6-2.8-1.2-4.6-4-4.7-4.2-.1-.2-1.1-1.4-1.1-2.7 0-1.3.7-1.9.9-2.2.2-.3.5-.3.7-.3h.5c.2 0 .4 0 .6.5l.8 2c.1.2.1.3 0 .5l-.3.5-.3.3c-.1.1-.3.3-.1.6.2.3.8 1.3 1.7 2.1 1.2 1 2.1 1.3 2.4 1.5.3.1.5.1.6-.1l.9-1c.2-.2.4-.2.6-.1l2 .9c.2.1.4.2.4.3.1.2.1.7-.1 1.2z"/></svg>';
  var LINK_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 3h7v7"/><path d="M10 14 21 3"/><path d="M21 14v7H3V3h7"/></svg>';

  function esc(v) {
    return String(v == null ? "" : v).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function digits(v) {
    return String(v || "").replace(/[٠-٩]/g, function (d) {
      return String(d.charCodeAt(0) - 0x0660);
    }).replace(/[۰-۹]/g, function (d) {
      return String(d.charCodeAt(0) - 0x06f0);
    }).replace(/\D/g, "");
  }

  function money(v) {
    var n = parseFloat(v);
    if (isNaN(n)) return "";
    return n.toLocaleString(isAr ? "ar-EG-u-nu-latn" : "en-EG", {
      minimumFractionDigits: 0, maximumFractionDigits: 2
    }) + " " + T.currency;
  }

  function fmtDate(v, withTime) {
    if (!v) return "";
    var d = new Date(v);
    if (isNaN(d.getTime())) return "";
    var opts = { year: "numeric", month: "long", day: "numeric" };
    if (withTime) { opts.hour = "2-digit"; opts.minute = "2-digit"; }
    try {
      return d.toLocaleDateString(isAr ? "ar-EG-u-nu-latn-ca-gregory" : "en-GB", opts);
    } catch (e) {
      return d.toISOString().slice(0, 10);
    }
  }

  /* ── shell ── */

  root.innerHTML =
    '<div class="fct-wrap">' +
      '<section class="fct-hero">' +
        "<h1>" + esc(T.title) + "</h1>" +
        "<p>" + esc(T.sub) + "</p>" +
        '<form class="fct-search" id="fct-form" novalidate>' +
          '<input id="fct-q" type="search" inputmode="numeric" autocomplete="off" placeholder="' + esc(T.ph) + '" aria-label="' + esc(T.ph) + '">' +
          '<input id="fct-phone" class="fct-phone" type="text" inputmode="numeric" maxlength="4" hidden placeholder="' + esc(T.phPhone) + '" aria-label="' + esc(T.phPhone) + '">' +
          '<button type="submit" id="fct-btn">' + esc(T.btn) + "</button>" +
        "</form>" +
        '<p class="fct-note" id="fct-note" role="status"></p>' +
      "</section>" +
      '<div class="fct-panel fct-state" id="fct-loading" hidden><div class="fct-spinner"></div><h2>' + esc(T.loading) + "</h2></div>" +
      '<div class="fct-panel fct-state" id="fct-error" hidden><h2>' + esc(T.errTitle) + "</h2><p>" + esc(T.errSub) + "</p></div>" +
      '<div id="fct-result"></div>' +
    "</div>";

  var form = document.getElementById("fct-form");
  var qEl = document.getElementById("fct-q");
  var phoneEl = document.getElementById("fct-phone");
  var btnEl = document.getElementById("fct-btn");
  var noteEl = document.getElementById("fct-note");
  var loadingEl = document.getElementById("fct-loading");
  var errorEl = document.getElementById("fct-error");
  var resultEl = document.getElementById("fct-result");

  var currentSig = "";

  /* ── rendering ── */

  function factsHtml(d) {
    var f = [];
    var o = d.shopifyOrder || {};
    if (d.trackingNumber) f.push(["#" + esc(d.trackingNumber), T.trackingNo]);
    if (o.createdAt) f.push([esc(fmtDate(o.createdAt)), T.placedOn]);
    if (d.currentState.code === 24 && d.deliveredAt) {
      f.push([esc(fmtDate(d.deliveredAt, true)), T.deliveredOn]);
    } else if (d.deliveryPromiseDate) {
      f.push([esc(fmtDate(d.deliveryPromiseDate)), T.promise]);
    }
    var c = d.customer || {};
    var area = [c.zone, c.city].filter(Boolean).join("، ");
    if (area) f.push([esc(area), T.address]);
    if (c.phoneMasked) f.push([esc(c.phoneMasked), T.phone]);
    if (d.numberOfAttempts > 0) f.push([esc(d.numberOfAttempts), T.attempts]);

    return f.map(function (row) {
      return "<div><span>" + esc(row[1]) + "</span><b>" + row[0] + "</b></div>";
    }).join("");
  }

  function timelineHtml(d) {
    var reached = {};
    var last = {};
    (d.events || []).forEach(function (e) {
      reached[e.code] = true;
      // Bosta repeats a code (out_for_return and returned_to_origin are both 46)
      // and does not order the array by date — keep the latest one.
      var prev = last[e.code];
      if (!prev || String(e.date || "") > String(prev.date || "")) last[e.code] = e;
    });
    var code = d.currentState.code;
    var alert = code === 47 || code === 48;
    var steps = STEP_ORDER.slice();
    if (alert) {
      // Keep the journey the shipment actually made, then close it with the
      // exception/return step instead of pretending a delivery is still coming.
      steps = STEP_ORDER.filter(function (s) { return s !== 24 && reached[s]; });
      if (steps.indexOf(10) === -1) steps.unshift(10);
      steps.push(code);
    }
    var currentIndex = steps.indexOf(code);
    if (currentIndex === -1) currentIndex = 0;

    return '<ol class="fct-steps">' + steps.map(function (s, i) {
      var done = alert ? i <= currentIndex : (reached[s] || i < currentIndex);
      var isCurrent = i === currentIndex;
      var ev = last[s];
      var cls = "fct-step" + (done ? " is-done" : " is-pending") +
        (isCurrent ? " is-current" : "") + (alert && isCurrent ? " is-alert" : "");
      return '<li class="' + cls + '">' +
        '<span class="fct-dot">' + (ICONS[s] || ICONS[10]) + "</span>" +
        "<h3>" + esc(T.steps[s] || "") + "</h3>" +
        (ev && ev.date ? "<time>" + esc(fmtDate(ev.date, true)) + "</time>" : "") +
        (ev && ev.desc ? "<small>" + esc(ev.desc) + "</small>" : "") +
        "</li>";
    }).join("") + "</ol>";
  }

  function itemsHtml(d) {
    var items = (d.shopifyOrder || {}).lineItems || [];
    if (!items.length) return "";
    return '<section class="fct-panel fct-items"><h2 class="fct-card-title">' + esc(T.items) + "</h2>" +
      items.map(function (it) {
        var img = it.imageUrl
          ? '<img src="' + esc(it.imageUrl) + '" alt="" loading="lazy" width="64" height="64">'
          : '<img alt="" width="64" height="64">';
        var sub = [it.variantTitle, T.qty + ": " + esc(it.quantity)].filter(Boolean).join(" · ");
        return '<div class="fct-item">' + img +
          '<div class="fct-item-body"><b>' + esc(it.title) + "</b><span>" + esc(sub) + "</span></div>" +
          '<div class="fct-item-price">' + esc(money(it.price)) + "</div></div>";
      }).join("") + "</section>";
  }

  function summaryHtml(d) {
    var o = d.shopifyOrder || {};
    if (!o.totalPrice) return "";
    var rows = "";
    if (o.subtotal) rows += '<div class="fct-sum-row"><span>' + esc(T.subtotal) + "</span><b>" + esc(money(o.subtotal)) + "</b></div>";
    if (o.shipping) rows += '<div class="fct-sum-row"><span>' + esc(T.shipping) + "</span><b>" + esc(money(o.shipping)) + "</b></div>";
    if (parseFloat(o.discount) > 0) rows += '<div class="fct-sum-row"><span>' + esc(T.discount) + "</span><b>- " + esc(money(o.discount)) + "</b></div>";
    rows += '<div class="fct-sum-row is-total"><span>' + esc(T.total) + "</span><b>" + esc(money(o.totalPrice)) + "</b></div>";
    return '<section class="fct-panel fct-summary"><h2 class="fct-card-title">' + esc(T.summary) + "</h2>" + rows + "</section>";
  }

  function render(d) {
    var o = d.shopifyOrder || {};
    var code = d.currentState.code;
    var tone = TONE[code] || "slate";
    var label = d.currentState.label || T.steps[code] || "";
    if (!isAr) label = d.currentState.labelEn || T.steps[code] || label;

    var alertBox = "";
    if (d.exceptionReason) {
      alertBox = '<div class="fct-alert">' + esc(d.exceptionReason) + "</div>";
    } else if (!d.shipped) {
      alertBox = '<div class="fct-alert" style="background:var(--fct-slate-bg);color:var(--fct-slate)">' + esc(T.notShipped) + "</div>";
    }

    resultEl.innerHTML =
      '<div class="fct-grid">' +
        '<section class="fct-panel fct-status">' +
          '<div class="fct-status-top">' +
            '<span class="fct-badge" data-tone="' + tone + '">' + (ICONS[code] || ICONS[10]) + esc(label) + "</span>" +
            '<div class="fct-order-id">' + esc(T.order) + " " + esc(o.orderName || "") +
              (o.createdAt ? "<span>" + esc(fmtDate(o.createdAt)) + "</span>" : "") +
            "</div>" +
          "</div>" +
          '<div class="fct-facts">' + factsHtml(d) + "</div>" +
          alertBox +
        "</section>" +
        '<section class="fct-panel fct-timeline"><h2 class="fct-card-title">' + esc(T.timeline) + "</h2>" +
          timelineHtml(d) +
        "</section>" +
        '<div class="fct-side">' + itemsHtml(d) + summaryHtml(d) + "</div>" +
        '<section class="fct-panel fct-help">' +
          "<span>" + esc(T.helpText) + "</span>" +
          "<span>" +
            '<a href="' + SUPPORT_WA + '" target="_blank" rel="noopener">' + WA_ICON + esc(T.helpBtn) + "</a>" +
            (d.courier && d.courier.trackingUrl
              ? ' <a href="' + esc(d.courier.trackingUrl) + '" target="_blank" rel="noopener">' + LINK_ICON + esc(T.bostaBtn) + "</a>"
              : "") +
          "</span>" +
        "</section>" +
      "</div>";
  }

  /* ── fetching ── */

  function setBusy(busy) {
    btnEl.disabled = busy;
    loadingEl.hidden = !busy;
    if (busy) { errorEl.hidden = true; resultEl.innerHTML = ""; }
  }

  function showError(msg) {
    errorEl.hidden = false;
    errorEl.querySelector("p").textContent = msg || T.errSub;
  }

  function lookup(query, opts) {
    opts = opts || {};
    var q = digits(query);
    if (!q) return;

    var params = [];
    if (opts.sig) params.push("sig=" + encodeURIComponent(opts.sig));
    if (opts.phone) params.push("phone=" + encodeURIComponent(digits(opts.phone)));
    if (opts.kind) params.push("kind=" + opts.kind);
    var url = API + encodeURIComponent(q) + (params.length ? "?" + params.join("&") : "");

    setBusy(true);
    noteEl.textContent = "";

    fetch(url, { method: "GET", mode: "cors", credentials: "omit", headers: { Accept: "application/json" } })
      .then(function (r) {
        return r.json().then(function (body) { return { status: r.status, body: body }; });
      })
      .then(function (res) {
        setBusy(false);
        var body = res.body || {};
        if (res.status === 200 && body.ok) {
          phoneEl.hidden = true;
          render(body);
          syncUrl(q, opts);
          resultEl.scrollIntoView({ behavior: "smooth", block: "start" });
          return;
        }
        if (body.error === "need_phone") {
          phoneEl.hidden = false;
          noteEl.textContent = opts.phone ? T.wrongPhone : T.needPhone;
          phoneEl.focus();
          return;
        }
        if (body.error === "rate_limited") { showError(T.rate); return; }
        showError(T.errSub);
      })
      .catch(function (e) {
        setBusy(false);
        console.error("[FootCourt tracker]", e);
        showError(T.offline);
      });
  }

  function syncUrl(q, opts) {
    if (!window.history || !history.replaceState) return;
    var qs = "?" + (opts.kind === "order" || q.length <= 7 ? "order=" : "tracking=") + encodeURIComponent(q);
    if (opts.sig) qs += "&sig=" + encodeURIComponent(opts.sig);
    history.replaceState(null, "", location.pathname + qs);
  }

  form.addEventListener("submit", function (e) {
    e.preventDefault();
    var q = qEl.value.trim();
    if (!digits(q)) { qEl.focus(); return; }
    lookup(q, {
      sig: currentSig,
      phone: phoneEl.hidden ? "" : phoneEl.value,
      kind: q.charAt(0) === "#" ? "order" : ""
    });
  });

  qEl.addEventListener("input", function () {
    // A new query invalidates the signed link and any phone already typed.
    currentSig = "";
    phoneEl.hidden = true;
    phoneEl.value = "";
    noteEl.textContent = "";
  });

  /* ── deep link: /pages/track-order?order=94128&sig=… ── */

  (function boot() {
    var p = new URLSearchParams(location.search);
    var order = p.get("order") || p.get("order_number") || "";
    var tracking = p.get("tracking") || p.get("t") || p.get("q") || p.get("shipment") || "";
    var sig = p.get("sig") || "";
    var value = digits(order) || digits(tracking);
    if (!value) { qEl.focus(); return; }
    currentSig = sig;
    qEl.value = value;
    lookup(value, { sig: sig, kind: digits(order) ? "order" : "" });
  })();
})();
